import React from "react";
import { Link } from "react-router-dom";
import {
  FiFacebook,
  FiInstagram,
  FiPhone,
  FiMail,
  FiMapPin,
} from "react-icons/fi";
import "./Footer.css";

const QUICK_LINKS = [
  { label: "All Services",       to: "/services" },
  { label: "Vehicle Cleaning",   to: "/services?category=vehicle-cleaning" },
  { label: "Household Cleaning", to: "/services?category=household-cleaning" },
  { label: "Laptop Repair",      to: "/services?category=laptop-repair" },
  { label: "Printer Repair",     to: "/services?category=printer-repair" },
  { label: "Electrician",        to: "/services?category=electrician" },
  { label: "Dress Iron",         to: "/services?category=dress-iron" },
  { label: "Hair Cutting",       to: "/services?category=hair-cutting" },
];

const Footer = () => (
  <footer
    className="footer"
    itemScope
    itemType="https://schema.org/LocalBusiness"
  >
    {/* Hidden machine-readable business name */}
    <meta itemProp="name" content="ExpertAtDoor" />
    <meta itemProp="url" content="https://www.expertatdoor.com" />
    <meta itemProp="telephone" content="+918981002675" />
    <meta itemProp="email" content="support@expertatdoor.com" />
    <span
      itemProp="address"
      itemScope
      itemType="https://schema.org/PostalAddress"
      style={{ display: "none" }}
    >
      <meta itemProp="addressLocality" content="Kolkata" />
      <meta itemProp="addressRegion" content="West Bengal" />
      <meta itemProp="addressCountry" content="IN" />
    </span>
    <span
      itemProp="aggregateRating"
      itemScope
      itemType="https://schema.org/AggregateRating"
      style={{ display: "none" }}
    >
      <meta itemProp="ratingValue" content="4.7" />
      <meta itemProp="reviewCount" content="50000" />
    </span>

    <div className="container">
      {/* ── Main row ── */}
      <div className="footer-main">
        {/* Brand */}
        <div className="footer-brand">
          <div className="footer-logo">
            <img
              src="expertAtDoorLogo1.jpeg"
              alt="ExpertAtDoor — Home Services in Kolkata"
              className="logo-image"
              style={{ width: "180px", height: "60px", borderRadius: "4px" }}
              width="180"
              height="60"
              loading="lazy"
            />
          </div>
          <p className="footer-tagline" itemProp="description">
            Bringing certified cleaning experts to your doorstep. Reliable,
            transparent and professional — across Kolkata.
          </p>

          {/* Trust badges */}
          <div className="footer-badges">
            <div className="footer-badge">✅ Verified Experts</div>
            <div className="footer-badge">🔒 Secure Booking</div>
            <div className="footer-badge">⭐ 4.7 Rated</div>
          </div>

          {/* Social */}
          <div className="footer-social">
            <a
              href="https://www.facebook.com/share/1ajDdcwrRg/"
              aria-label="ExpertAtDoor on Facebook"
              rel="noopener noreferrer"
              target="_blank"
            >
              <FiFacebook size={16} />
            </a>
            <a
              href="https://www.instagram.com/expertatdoor?igsh=MW9tNm5leXEzdGJqNQ=="
              aria-label="ExpertAtDoor on Instagram"
              rel="noopener noreferrer"
              target="_blank"
            >
              <FiInstagram size={16} />
            </a>
          </div>
        </div>

        {/* Divider */}
        <div className="footer-divider-v" />

        {/* Quick Links — important for crawlability */}
        <nav className="footer-contact-col" aria-label="Quick links">
          <h4 className="footer-col-heading">Our Services</h4>
          <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
            {QUICK_LINKS.map(({ label, to }) => (
              <li key={to} style={{ marginBottom: "6px" }}>
                <Link
                  to={to}
                  style={{ color: "var(--brand-text-muted)", textDecoration: "none", fontSize: "0.9rem" }}
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        {/* Divider */}
        <div className="footer-divider-v" />

        {/* Contact */}
        <address className="footer-contact-col" style={{ fontStyle: "normal" }}>
          <h4 className="footer-col-heading">Get in Touch</h4>

          <a href="tel:+918981002675" className="footer-contact-item" itemProp="telephone">
            <span className="contact-icon">
              <FiPhone size={15} />
            </span>
            <span>+91 89810 02675</span>
          </a>
          <a
            href="mailto:support@expertatdoor.com"
            className="footer-contact-item"
            itemProp="email"
          >
            <span className="contact-icon">
              <FiMail size={15} />
            </span>
            <span>support@expertatdoor.com</span>
          </a>
          <div className="footer-contact-item" itemProp="address">
            <span className="contact-icon">
              <FiMapPin size={15} />
            </span>
            <span>Kolkata, West Bengal, India</span>
          </div>

          <div className="footer-hours">
            <p className="hours-label">Working Hours</p>
            <p itemProp="openingHours" content="Mo-Sa 10:00-19:00">
              Mon – Sat &nbsp;·&nbsp; 10 AM – 7 PM
            </p>
          </div>
        </address>
      </div>

      {/* ── Bottom bar ── */}
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} ExpertAtDoor. All rights reserved.</p>
        <div className="footer-bottom-links">
          <Link to="/privacy">Privacy Policy</Link>
          <span className="footer-dot">·</span>
          <Link to="/terms">Terms of Service</Link>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
